import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CloudCheckFilledSvg = function CloudCheckFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#61676B",
    fillRule: "evenodd",
    d: "M12 0a7 7 0 0 0-6.39 4.138 7.002 7.002 0 0 0-.83 13.503l3.53-3.53 2.15 2.149 4.806-6.008 5.467 4.373-2.7 3.375a6 6 0 0 0 .906-11.927A7 7 0 0 0 12 0m-1.126 23.746 7.047-8.809-2.342-1.874-4.953 6.191L8.31 16.94l-2.122 2.122z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var CloudCheckFilled = function CloudCheckFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CloudCheckFilledSvg
  }));
};